<template>
  <div class="wrapper d-flex justify-content-center align-items-center">
    <div class="boxes shadow">
      <h1 class="text-center fs-4">APLIKASI DATA PERTANIAN</h1>
      <hr class="my-4">
      <h2 class="text-dark">Log in</h2>
      <p>Sebelum masuk ke sistem</p>
      <!-- Belum nemu cara auto hidenya ketika onfocus input -->
      <div v-if="show_alert" class="alert alert-danger" role="alert">
        Username / Password salah.
      </div>
      <form method="post" @submit.prevent="login">
        <div class="py-3">
          <div class="mb-3">
            <input @focusin="hideAlert" type="text" v-model="form.username" class="form-control" placeholder="Username" autofocus autocapitalize="off" />
          </div>
          <div class="input-group mb-3">
            <input :type="(showpass ? 'text':'password')" v-model="form.password" class="form-control" placeholder="Password" />
            <div class="input-group-append">
              <span class="input-group-text cp" @mousedown="start" @mouseleave="stop" @mouseup="stop" @touchstart="start" @touchend="stop" @touchcancel="stop">
                <icon v-if="showpass" :icon="['far', 'eye']" />
                <icon v-if="!showpass" :icon="['far', 'eye-slash']" />
              </span>
            </div>
          </div>
          <div class="form-check">
            <input class="form-check-input" v-model="form.remember" type="checkbox" id="remember-me" />
            <label class="form-check-label" for="remember-me">Ingat Saya</label>
          </div>
          <div class="mt-3">
            <Link href="/"><p>Kembali ke Halaman Awal</p></Link>
          </div>
        </div>
        <div class="py-2 text-end">
          <button type="submit" class="btn btn-primary px-4">Masuk</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errors: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        username: '',
        password: '',
        remember: false,
      }),
      showpass: false,
      show_alert: false
    }
  },
  methods: {
    login() {
      this.form.post('/auth/login')
    },
    start() {
      if (!this.showpass) {
        this.showpass = setInterval(() => {}, 30)
      }
    },
    stop() {
      clearInterval(this.showpass)
      this.showpass = false
    }
  },
  beforeUpdate() {
    this.show_alert = Object.keys(this.errors).length !== 0
  }
}
</script>

<style lang="scss">
@import '../../../css/bootstrap';
</style>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #1b2c3f;
}

.boxes {
  padding: 3.5rem 2.5rem;
  background: #fff;
  width: 100%;
  max-width: 30em;
}

.form-control, .input-group-text {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
}

.input-group-text {
  padding: 0.47rem 0.75rem;
  display: block;
  cursor: pointer;
}

.form-check-label {
  font-weight: normal;
}
</style>